import { DeleteOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import React from "react";
import { formatCurrency } from "../../../../libs/utils";
import { dateByformat } from "../../../../../utils/dateHelper";
import { AllocationInput } from "./AllocationInput";
import { ReceiptInvoiceAllocationRow } from "./types";
import { convertToNormalCase, getRemainingBalance } from "./utils";
import styles from "./ReceiptMultiInvoiceAllocation.module.scss";

const { Text } = Typography;

type AllocationRowCellsProps = {
  record: ReceiptInvoiceAllocationRow;
  disabled?: boolean;
  onAllocationChange: (id: string, value: number) => void;
  onAllocationInputValidityChange?: (id: string, isValid: boolean) => void;
  onRemove: (id: string) => void;
  onInvoiceClick?: (invoice: ReceiptInvoiceAllocationRow) => void;
};

export const AllocationRowCells = {
  InvoiceNo: ({ record, onInvoiceClick }: Pick<AllocationRowCellsProps, "record" | "onInvoiceClick">) => (
    // <Link className={styles.invoiceLink} onClick={() => onInvoiceClick?.(record)}>
    <> {record.invoiceNo}</>
    // </Link>
  ),

  Type: ({ record }: Pick<AllocationRowCellsProps, "record">) => (
    <Text className={styles.cellText}>{record.type ? convertToNormalCase(record.type) : "--"}</Text>
  ),

  DueDate: ({ record }: Pick<AllocationRowCellsProps, "record">) => (
    <Text className={styles.cellText}>{record.dueDate ? dateByformat(record.dueDate, "DD-MM-YYYY") : "--"}</Text>
  ),

  InvoiceAmount: ({ record }: Pick<AllocationRowCellsProps, "record">) => (
    <span className={styles.numericCell}>{formatCurrency(record.invoiceAmount, { symbol: false })}</span>
  ),

  Balance: ({ record }: Pick<AllocationRowCellsProps, "record">) => {
    const balance = Math.max(0, Number(record.balance) || 0);
    const allocation = record.selected ? Math.max(0, Number(record.allocation) || 0) : 0;
    const remaining = getRemainingBalance(record);
    const isSettled = record.selected && allocation > 0 && allocation >= balance;
    const isPartial = record.selected && allocation > 0 && allocation < balance;

    return (
      <div className={styles.balanceCell}>
        <span className={styles.balanceAmount}>{formatCurrency(remaining, { symbol: true })}</span>
        {isSettled && <span className={styles.settledLabel}>Settled</span>}
        {isPartial && <span className={styles.partialLabel}>Partial</span>}
      </div>
    );
  },

  Allocation: ({ record, disabled, onAllocationChange, onAllocationInputValidityChange }: AllocationRowCellsProps) => (
    <AllocationInput
      value={Number(record.allocation) || 0}
      maxBalance={Number(record.balance) || 0}
      disabled={disabled || !record.selected}
      onChange={(nextValue) => onAllocationChange(record.id, nextValue)}
      // onValidityChange={(isValid) => onAllocationInputValidityChange?.(record.id, isValid)}
    />
  ),

  Actions: ({ record, disabled, onRemove }: AllocationRowCellsProps) =>
    record.removable ? (
      <Button
        type="text"
        size="small"
        className={styles.deleteBtn}
        disabled={disabled}
        icon={<DeleteOutlined />}
        onClick={() => onRemove(record.id)}
      />
    ) : null,
};
